module.exports = __webpack_public_path__ + "media/images/SentMail-1ea6248b.svg";